export default __webpack_public_path__ + "static/efre-187277b4fe3a6f2adaf8debc8bf099a7.svg";